import React from "react";
import HeroImage from "../components/HeroImage";

import backgroundimage from "../assets/images/contact.png";
import ContactForm from "../components/ContactForm";
import { useLocation } from "react-router-dom";

function ContactUs() {
  const location = useLocation();
  const { combi } = location.state || {};

  console.log(combi);

  return (
    <div>
      <HeroImage backgroundImage={backgroundimage} />
      <ContactForm carName={combi} />
    </div>
  );
}

export default ContactUs;
